import React, { useContext } from 'react';

import { CuiIntegrationsConnection } from '../../../../connection-components/integrations-connection';
import { enums } from '../constants';
import { IntegrationsContext } from '../context';
import style from '../style.module.less';
import MailChimpSettings from './settings';

export const MailChimp = () => {
  const { integrations } = useContext(IntegrationsContext);
  if (!integrations) {
    return null;
  }

  const MailChimpAppId = enums.mailchimp;

  const mailChimpIntegrations = integrations.find((i) => parseInt(i.integratedAppID, 10) === MailChimpAppId);

  if (mailChimpIntegrations?.count > 0) {
    return <MailChimpSettings />;
  }

  return (
    <div className={style['cui-container']}>
      <CuiIntegrationsConnection integrationAppId={MailChimpAppId} />
    </div>
  );
};
